import {
  LOGIN_SUCCESS,
  LOGOUT,
  AUTH_TOKEN_REFRESH,
  AUTH_UPDATE_SETTING_DATETIME,
  AUTH_NOTIFICATION_REFRESH,
  START_REFRESH_INTERVAL,
  STOP_REFRESH_INTERVAL,
} from "../../constants/actionTypes";
import isEmpty from "lodash/isEmpty";

// Function help to get auth from local storage or init state
const getAuthInitState = () => {
  const authItem = localStorage.getItem("auth");
  if (isEmpty(authItem)) {
    return {
      access_token: null,
      refresh_token: null,
      isAuthenticated: false,
      last_update_datetime: null,
      notifications: null,
      user: {},
      intervalId: null,
    };
  }
  return JSON.parse(authItem);
};

const initialState = getAuthInitState();

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      let authState = {
        access_token: action.payload.access,
        refresh_token: action.payload.refresh,
        isAuthenticated: true,
        last_update_datetime: action.payload.last_update_datetime,
        notifications: action.payload.notifications,
        user: action.payload.user,
      };
      let authItem = JSON.stringify(authState);
      localStorage.setItem("auth", authItem);
      return authState;
    case LOGOUT:
      localStorage.removeItem("auth");
      sessionStorage.clear();
      return {
        access_token: null,
        refresh_token: null,
        isAuthenticated: false,
        last_update_datetime: null,
        notifications: null,
        user: {},
      };
    case AUTH_UPDATE_SETTING_DATETIME:
      state.last_update_datetime = action.payload;
      localStorage.setItem("auth", JSON.stringify(state));
      return state;

    case AUTH_NOTIFICATION_REFRESH:
      state.notifications = action.payload;
      localStorage.setItem("auth", JSON.stringify(state));
      return state;

    case AUTH_TOKEN_REFRESH:
      const localAuthState = localStorage.getItem("auth");
      const localAuthItem = JSON.parse(localAuthState);
      if (localAuthItem?.access_token) {
        localAuthItem.access_token = action.payload;
        localStorage.setItem("auth", JSON.stringify(localAuthItem));
      }
      return localAuthItem;
    case START_REFRESH_INTERVAL:
      const lauthState = localStorage.getItem("auth");
      const lauthItem = JSON.parse(lauthState);
      lauthItem.intervalId = action.payload;
      localStorage.setItem("auth", JSON.stringify(lauthItem));
      return {
        ...lauthItem,
        intervalId: action.payload,
      };
    case STOP_REFRESH_INTERVAL:
      return {
        access_token: null,
        refresh_token: null,
        isAuthenticated: false,
        last_update_datetime: null,
        notifications: null,
        user: {},
      };
    default:
      return state;
  }
};

export default authReducer;
